import breakpoints from 'typescript/styles/breakpoints.module.scss';

const xs = Number.parseInt(breakpoints.xs, 10);
const sm = Number.parseInt(breakpoints.sm, 10);
const md = Number.parseInt(breakpoints.md, 10);
const lg = Number.parseInt(breakpoints.lg, 10);
const xl = Number.parseInt(breakpoints.xl, 10);

export { xs, sm, md, lg, xl };
